import { Reveal, SectionTitle } from "@/components/site/Reveal";
import { FAQ } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqSection = () => (
  <section id="faq" className="py-20 sm:py-28 px-5 sm:px-8 bg-cream">
    <div className="max-w-3xl mx-auto">
      <Reveal>
        <SectionTitle overline="FAQ" title="Vos questions, nos réponses" />
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQ.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="rounded-2xl bg-white border border-beige px-6 shadow-soft">
              <AccordionTrigger className="text-left font-heading text-xl font-semibold text-chocolate hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-cocoa leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
